<template>
  <div class="flex max-w-[1440px] mx-auto h-full font-poppins bg-white">
    <!-- Panel izquierdo -->
    <div class="w-full sm:w-1/2 flex flex-col bg-white min-h-screen">
      <!-- Encabezado -->
      <HeaderComponent class="md:mb-6 mb-4" />
      <!-- Contenido -->
      <div class="mb-4 mx-auto px-5 md:p-0 md:ml-[80px] md:mx-0 w-11/12 md:w-3/4 max-w-[384px] bg-white">
        <!-- Barra de progreso -->
        <div class="flex justify-between mb-0">
          <span></span>
          <span class="text-sm font-medium text-custom_gray">{{ currentStep + 1 }}/4</span>
        </div>
        <div class="md:mb-6 mb-3 w-full bg-[#D9D9D9] rounded-full h-2.5">
          <div class="bg-tuin-100 h-2.5 rounded-full" :style="{ width: progressPercentage + '%' }"></div>
        </div>

        <!-- Título -->
        <div class="text-center">
          <h5 class="lg:text-32 text-lg font-medium text-custom_black mb-2 mt-10">
            ¡Te damos la bienvenida, {{ userName }}!
          </h5>
          <p class="text-custom_gray font-normal text-sm lg:text-base not-italic mb-4">
            Tu registro fue exitoso. Haz clic en Continuar para entrar al panel administrativo
          </p>
      
          <button 
            @click="goToHome"
            class="w-full text-white bg-tuin_base-0 hover:bg-tuin_hover focus:outline-none focus:ring-transparent not-italic font-semibold rounded-lg text-base/[18px] px-5 py-2.5 text-center"
          >
            Continuar
          </button>
        </div>

      </div>
    </div>

    <!-- Panel derecho con imagen -->
    <div class="hidden w-1/2 sm:flex items-center justify-center">
      <div>
        <img
          src="@/assets/imgs/LoginTuin.svg"
          alt="Tuin hora de hacer magia"
          class="max-h-[666px] max-w-[856px]"
        >
      </div>
    </div>
  </div> <!-- Cierre del div raíz -->
</template>

<script setup>
import { ref, computed, onMounted} from 'vue';
import axios from 'axios';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import HeaderComponent from '@/components/login/HeaderComponent.vue';

// Store, router y session
const store = useStore();
const router = useRouter();
const route = useRoute();
const session = computed(() => store.getters.getUserSession);

// Variables
const currentStep = ref(3);
const progressPercentage = computed(() => ((currentStep.value + 1) / 4) * 100);
const error = ref('');
const selectedCountryCode = ref('');
const userPhoneNumber = ref('');
const userProfile = ref(null);
const userName = ref('');

// Iniciar el temporizador cuando se monta el componente
onMounted(async () => {
  // Intentar obtener el número de teléfono de la ruta primero
  if (route.query.phone) {
    userPhoneNumber.value = route.query.phone;
    
    // Intentar obtener el código de país de la ruta
    if (route.query.countryCode) {
      selectedCountryCode.value = route.query.countryCode;
    } else {
      // Si no está en la ruta, obtenerlo del perfil del usuario
      await getProfile();
    }
  } else {
    // Si no está en la ruta, obtenerlo del perfil del usuario
    await getProfile();
  }
  
});
async function goToHome() {
  // Redirigir directamente a la página de propiedades
  window.location.href = "/home";  // Redirige directamente al panel
}
/*
const updateStep = async (stepNumber) => {
  try {
    const url = `${process.env.VUE_APP_API_BASE_URL}/profile/save-step/${session.value.id}`;
    
    const options = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    const response = await axios.post(url, { step: stepNumber }, options);
    
    if (response.status === 200) {
      console.log('Paso actualizado correctamente');
    }
  } catch (err) {
    console.error('Error actualizando el paso:', err.response?.data || err);
    error.value = err.response?.data?.message || "Error al actualizar el paso";
  }
};*/

// Obtener el perfil del usuario para conseguir su número de teléfono
async function getProfile() {
  if (!session.value || !session.value.token_api || !session.value.id) {
    error.value = "No se encontró la sesión del usuario. Vuelve a iniciar sesión.";
    return;
  }
  
  try {
    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };
    
    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/broker/profile/${session.value.id}`,
      options
    );
    
    if (response.status == 200) {
      userProfile.value = response.data.resp;
      
      // Extraer el código de país y el número de teléfono directamente de la respuesta
      if (userProfile.value) {
        // Establecer nombre completo desde info.full_name
        userName.value = userProfile.value.info.name || 'Usuario';

        // Código existente
        selectedCountryCode.value = response.data.resp.phone_country_code || '+52';

        if (userProfile.value.info && userProfile.value.info.phone) {
          userPhoneNumber.value = userProfile.value.info.phone;
        } else {
          userPhoneNumber.value = '';
        }
      }
    }
  } catch (error) {
    let response = error.response;
    if (response && response.status == 401) {
      store.dispatch("clearUserSession");
      router.push({ name: 'login' });
    }
    console.error("Error fetching profile data:", error.response);
  }
}


</script>
